import { render, staticRenderFns } from "./AllocationOrd.vue?vue&type=template&id=a4642ada"
import script from "./AllocationOrd.vue?vue&type=script&lang=js"
export * from "./AllocationOrd.vue?vue&type=script&lang=js"
import style0 from "./AllocationOrd.vue?vue&type=style&index=0&id=a4642ada&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4642ada')) {
      api.createRecord('a4642ada', component.options)
    } else {
      api.reload('a4642ada', component.options)
    }
    module.hot.accept("./AllocationOrd.vue?vue&type=template&id=a4642ada", function () {
      api.rerender('a4642ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/AllocationOrd.vue"
export default component.exports